export interface SalesDespatchProductSummaryReport {
  productKey: string;
  productDescription: string;
  composition: string;
  tariffCode: string;
  nettQuantity: number;
  value: number;
}
